export default "__VITE_ASSET__2_L232qo__"